"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shortAddress = void 0;
var shortAddress = function (address, pads) {
    if (pads === void 0) { pads = 5; }
    var firstLetters = address.substr(0, pads);
    var endingLetters = address.substr(-pads, pads);
    return firstLetters + "..." + endingLetters;
};
exports.shortAddress = shortAddress;
